import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, NgForm  } from '@angular/forms';
import { AuthService } from '../../shared/services/auth/auth.service';
import { Router, ActivatedRoute, Params, RouterLink } from '@angular/router';
import { ToastService } from '../../shared/services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {StaticValueService} from '../../shared/services/static-value.service'
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  public username;
  public user: any;
  public userNameExistBool: Boolean = false;
  public emailSentBool: Boolean = false;
  public language = 'english';

  constructor( public route: ActivatedRoute,
    public authService: AuthService,
    public toastService: ToastService,
    public translateService: TranslateService,
    public staticService: StaticValueService,
    public router: Router ) {
      if (this.staticService.getLanguage()) {
        this.translateService.use(this.staticService.getLanguage());
        this.language = this.staticService.getLanguage();
    }else {
        this.translateService.use('english')
        this.translateService.setDefaultLang('english');
    }
    }

  ngOnInit() {
    this.route.params.subscribe(params => {
    });
  }

  sendEmail() {
    this.username = this.username.toLowerCase();
    this.authService.getUserByUsername(this.username).subscribe(data => {
      this.user = data[0];
      console.log(this.user);
      if (this.user !== undefined) {
        if (this.user.username === this.username ) {
          this.emailSentBool = true;
          this.userNameExistBool = false;
           this.username = this.username;
          this.authService.passwordResetEmail(this.username).subscribe(user => {
            this.toastService.success();
          }, error => {
            this.toastService.error('Something went wrong');
          })
        } else {
          this.userNameExistBool = true;
        }
    } else {
        this.userNameExistBool = true;
      }
    }, error => {
    });

  }

  languageChange(lang:string){
    this.translateService.use(lang);
    this.language=lang;
    this.staticService.setLanguage(lang);
  }
backToLogin() {
  this.router.navigate(['login']);
  }
}
